//------------------//
// Alpine.js
//------------------//
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
global.Alpine = Alpine;

Alpine.plugin(collapse);
Alpine.start();





//------------------//
// Lazy load images
//------------------//
import Lazyload from 'vanilla-lazyload';
global.Lazyload = Lazyload;

// Create Lazy load instance
var lazyLoadInstance = new Lazyload({
    elements_selector: '.lazy'
    // ... more custom settings?
});
global.lazyLoadInstance = lazyLoadInstance;





//------------------//
// Swiper JS
//------------------//
import Swiper, { Pagination } from 'swiper';
// import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
global.Swiper = Swiper;
global.Pagination = Pagination;





//------------------//
// Fancybox
//------------------//
import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
// global.Fancybox = Fancybox;

Fancybox.bind("[data-fancybox]");





//------------------//
// GSAP
//------------------//
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);
// gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const smoother = ScrollSmoother.create({
    wrapper: '#smooth-wrapper',
    content: '#smooth-content',
    // smooth: false,
    effects: true
});


// document.querySelectorAll(".fade-in-letters").forEach(function(title) {
//     gsap.to(title,{
//         xPercent: -10,
//         ease: "none",
//         scrollTrigger: {
//             trigger: title,
//             // markers: true,
//             scrub: true,
//             id: 'Animated Titles',
//         }
//     })
// });




//------------------//
// Transition in elements
//------------------//
const transition_elements = gsap.utils.toArray('[data-transition]');

transition_elements.forEach((el) => {

    const data_offset       = el.dataset.transitionOffset; // Expects it to either be percentage "50%" or just a number "300" for exact pixels
    const data_animation    = el.dataset.transition || 'fade-in'; // 'fade-in', 'fade-up', 'fade-left', 'fade-right'
    const data_duration     = parseFloat(el.dataset.transitionDuration) || 1; // in seconds
    const data_delay        = el.dataset.transitionDelay ? parseInt(el.dataset.transitionDelay) / 1000 : 0; // in milliseconds

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: el,
            start: (/%$/.test(data_offset)) ? `${data_offset} bottom` : data_offset ? `top+=${data_offset}px bottom` : 'top+=100px bottom',
            end: 'bottom bottom',
            // markers: true,
            toggleActions: 'play none none reverse'
        }
    });

    switch (data_animation) {
        case 'fade-in':
            tl.fromTo(el, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1,
                duration: data_duration,
                delay: data_delay,
                clearProps: 'all',
            });
            break;
        case 'fade-up':
            tl.fromTo(el, {
                autoAlpha: 0,
                y: 25
            }, {
                autoAlpha: 1,
                y: 0,
                duration: data_duration,
                delay: data_delay,
                clearProps: 'all',
            });
            break;
        case 'fade-left':
            tl.fromTo(el, {
                autoAlpha: 0,
                x: 25
            }, {
                autoAlpha: 1,
                x: 0,
                duration: data_duration,
                delay: data_delay,
                clearProps: 'all',
            });
            break;
        case 'fade-right':
            tl.fromTo(el, {
                autoAlpha: 0,
                x: -25,
            }, {
                autoAlpha: 1,
                x: 0,
                duration: data_duration,
                delay: data_delay,
                clearProps: 'all',
            });
            break;
    }
});




gsap.timeline({ defaults: { opacity: 0, duration: 1, ease: 'power2.out' } })
    .from('#stallion-hero .stallion-headshot', {x: 25, duration: 2})
    .from('#stallion-hero .stallion-logo', {y: 25}, '<0.5')
    .from('#stallion-hero .stallion-hero-content', {y: 25}, '<0.25')
    .from('#stallion-hero .stallion-lte', {y: 25}, '<0.25');




document.querySelectorAll(".stagger-animation").forEach(function(container) {
    const staggerItems = container.querySelectorAll(".stagger-item");
    gsap.from(staggerItems, {
        opacity: 0,
        y: 25,
        duration: 1.5,
        ease: 'power2.out',
        stagger: 0.2,
        scrollTrigger: {
            trigger: container,
            start: "+=100px bottom",
            // markers: true,
            toggleActions: "play none none reverse",
        },
    });
});


//------------------------------------
// Buttons that scroll down the page
//------------------------------------
gsap.utils.toArray("[data-scroll-to]").forEach(function (button, i) {
    button.addEventListener("click", (e) => {
        var id = e.target.getAttribute("data-scroll-to");
        smoother.scrollTo(id, true, "top 100px");
        e.preventDefault();
    });
});

window.onload = (event) => {
    let urlHash = window.location.href.split("#")[1];
    let scrollElem = document.querySelector("#" + urlHash);

    if (urlHash && scrollElem) {
        gsap.to(smoother, {
            scrollTop: smoother.offset(scrollElem, "top 100px"),
            duration: 1,
            delay: 0.5
        });
    }
};


//------------------//
// Image Scale Animation
//------------------//
document.querySelectorAll(".image-scale-animation").forEach(function(image) {
    gsap.from(image, {
        scale: 1.1,
        opacity: 0,
        duration: 1.5,
        ease: 'power2.out',
        scrollTrigger: {
            trigger: image.parentNode,
            start: "+=200px bottom",
            id: "Image Scale Animation",
            // markers: true,
            toggleActions: "play none none reverse",
        },
    });
});







document.querySelectorAll(".horizontal-gallery").forEach(function(container) {
    gsap.to(container, {
        x: -200,
        ease: "none",
        scrollTrigger: {
            trigger: container,
            scrub: true,
            // markers: true,
        },
    })
});






//------------------//
// Glowing card effect
//------------------//
function cardGlow() {
    const cardGlows = document.getElementsByClassName('card-glow');

    for (const cardGlow of cardGlows) {
        cardGlow.addEventListener('mousemove', e => {

            const rect = cardGlow.getBoundingClientRect(),
            x = e.clientX - rect.left,
            y = e.clientY - rect.top;

            cardGlow.style.setProperty('--mouse-x', `${x}px`);
            cardGlow.style.setProperty('--mouse-y', `${y}px`);
        });
    }
}
cardGlow();
global.cardGlow = cardGlow;
